export interface WorkingDayTypeClass {
    AccountWorkingDayTypeId: number
    AccountId: number
    AccountWorkingDayType: string
    HoursPerDay: number
    WeekStartDay:number
    CreatedByEmployeeId: number
    CreatedOn: Date | undefined
    ModifiedByEmployeeId: number
    ModifiedOn: Date | undefined
    IsDisabled: boolean
    MinimumHoursPerDay: number
    MaximumHoursPerDay: number
    MinimumHoursPerWeek: number
    MaximumHoursPerWeek: number
    AccountTimesheetPeriodTypeId: string
    TimesheetOverdueAfterDays: number 
    MinimumPercentagePerDay: number
    MaximumPercentagePerDay: number
    MinimumPercentagePerWeek: number
    MaximumPercentagePerWeek: number
    LockAllPreviousTimesheets: boolean
    LockAllFutureTimesheets: boolean
    LockPreviousTimesheetPeriods: number
    LockFutureTimsheetPeriods: number
    LockPreviousNextMonthTimesheetOn: number
    EnableBalanceValidationForTimeOff: boolean
    LockAllPeriodExceptPrevious: number
    LockAllPeriodExceptNext: number
    ShowClockStartEndEmployee: boolean
    IsDeleted: boolean    
    isSelected:number
}

export const workingdaytypeInitialsForApp = {
    AccountWorkingDayType: "",
    HoursPerDay: 8,
    WeekStartDay: 0,
    MinimumHoursPerDay: 0,
    MaximumHoursPerDay: 0,
    MinimumHoursPerWeek: 0,
    MaximumHoursPerWeek: 0,
    AccountTimesheetPeriodTypeId: "",
    TimesheetOverdueAfterDays: 0,
    MinimumPercentagePerDay: 0,
    MaximumPercentagePerDay: 0,
    MinimumPercentagePerWeek: 0,
    MaximumPercentagePerWeek: 0,
    LockAllPreviousTimesheets: false,
    LockAllFutureTimesheets: false,
    LockPreviousTimesheetPeriods: 0,
    LockFutureTimsheetPeriods: 0,
    LockPreviousNextMonthTimesheetOn: 0,
    EnableBalanceValidationForTimeOff: false,
    LockAllPeriodExceptPrevious: 0,
    LockAllPeriodExceptNext: 0,
    ShowClockStartEndEmployee: false,
    WorkingDayNo: []
}

export const workingdaytypeInitialsForUpdate = {
    AccountWorkingDayType: "",
    HoursPerDay: 8,
    WeekStartDay: 0,
    MinimumHoursPerDay: 0,
    MaximumHoursPerDay: 0,
    MinimumHoursPerWeek: 0,
    MaximumHoursPerWeek: 0,
    AccountTimesheetPeriodTypeId: "",
    TimesheetOverdueAfterDays: 0,
    MinimumPercentagePerDay: 0,
    MaximumPercentagePerDay: 0,
    MinimumPercentagePerWeek: 0,
    MaximumPercentagePerWeek: 0,
    LockAllPreviousTimesheets: false,
    LockAllFutureTimesheets: false,
    LockPreviousTimesheetPeriods: 0,
    LockFutureTimsheetPeriods: 0,
    LockPreviousNextMonthTimesheetOn: 0,
    EnableBalanceValidationForTimeOff: false,
    LockAllPeriodExceptPrevious: 0,
    LockAllPeriodExceptNext: 0,
    ShowClockStartEndEmployee: false,    
    AccountWorkingDayTypeId: "",
    SystemTimesheetPeriodType:"",
    WeekStartsOn: "",
    WorkingDayNo: "",
    WorkingDays: ""
}